export * from './remitos-filtros-dialog.component';




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-home/remitos-filtros-dialog/index.ts